import { isWelcomeRoute } from "@/src/hooks/onboarding/isOnboardingRoute";
import type { NativeStatusBarStyle } from "@/src/lib/bridge/types";

/** 按 pathname 解析应同步给原生的状态栏样式。 */
export function resolveNativeStatusBarStyle(
  pathname: string,
): NativeStatusBarStyle {
  if (isWelcomeRoute(pathname)) {
    return "dark";
  }
  return "auto";
}
